"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoeEmbed1Schema = void 0;
exports.ZoeEmbed1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/zoe-embed/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ZoeEmbed1",
    "description": "Embed a zone of engagement (ZOE) asset",
    "type": "object",
    "properties": {
        "type": {
            "const": "rrn:content:ext:services:zoe-embed:1"
        },
        "attributes": {
            "type": "object",
            "properties": {
                "zoeId": {
                    "type": "string",
                    "description": "The zone of engagement id for the embedded asset"
                }
            },
            "required": [
                "zoeId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy96b2UtZW1iZWQvMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxlQUFlLEdBQUc7SUFDN0IsS0FBSyxFQUFFLDhFQUE4RTtJQUNyRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxXQUFXO0lBQ3BCLGFBQWEsRUFBRSx3Q0FBd0M7SUFDdkQsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sT0FBTyxFQUFFLHNDQUFzQztTQUNoRDtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixPQUFPLEVBQUU7b0JBQ1AsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxrREFBa0Q7aUJBQ2xFO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsT0FBTzthQUNSO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=